import React, { useState, useContext } from "react";

import { Slider, Typography, Stack, Box, Divider } from "@mui/material";

import { SettingsOptionsContext } from "../SettingsOptions";
interface SettingsSliderProps {
  /**
   * Default value of the slider;
   */
  defaultValue: number;
  /**
   * Character to display after value
   */
  endCharacter?: string;
  /**
   * Acts as the identifier of the settings option.
   */
  keyid: string;
  /**
   * Label to be displayed in the UI
   */
  label: string;
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   */
  marks?: { value: number, label: string }[];
  /**
   * The maximum allowed value of the slider & should not be equal to min.
   */
  max?: number;
  /**
   * The minimum allowed value of the slider & should not be equal to max.
   */
  min?: number;
  /**
   * Determines whether or not the active value should be displayed to the right
   */
  showCurrentValue?: boolean;
  /**
   * Value of slider, used as first value for slider value state.
   */
  sliderValue: number;
  /**
   * The granularity with which the slider can step through values.
   */
  step?: number;
}

export default function SettingsSlider(props: SettingsSliderProps) {
  const settignsOptions = useContext(SettingsOptionsContext);
  const [sliderValue, setSliderValue] = useState<number>(props.sliderValue ?? props.defaultValue);

  return (
   <Stack direction="row" sx={{
    alignItems: "center"
   }}>
    <Typography sx={{ flex: 1, marginRight: 3 }}>{props.label}</Typography>
    <Box className="drag-cancel" sx={{ flex: 2, marginRight: 2, marginLeft: props.showCurrentValue ? 3 : 0 }}>
      <Slider
        marks
        max={props.max ?? 20}
        min={props.min ?? 1}
        onChange={(e, newValue: number | number[]) => {
          settignsOptions?.updateSettingsState(props.keyid, newValue);
          setSliderValue(newValue as number);
        }}
        step={props.step ?? 1}
        value={sliderValue} />
    </Box>
    {props.showCurrentValue &&
      <>
        <Divider flexItem orientation="vertical" sx={{ width: "2px" }} />
        <Box sx={{ pl: 1, pr: 1, width: "10%" }}>{sliderValue}{props.endCharacter}</Box>
      </>}
   </Stack>
  );
}